import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import basharaat from "../assets/images/BashaaratLogo.svg";

import profile from "../assets/images/icons/company_profile.svg";
import DashboardIcon from "../assets/images/icons/dashboard.svg";
import userIcon from "../assets/images/icons/user.svg";
import approvapending from "../assets/images/approval-pending.png";
import packageIcon from "../assets/images/icons/package_icon.svg";
import api from "../services/api";

const sidebarData = [
  { title: "Dashboard", path: "/dashboard", icon: DashboardIcon },
  { title: "Company Profile", path: "/profile-view", icon: profile },
  { title: "Manage Lead", path: "/manage-user", icon: userIcon },
  { title: "Manage Package", path: "/manage-package", icon: packageIcon },
  {title:"Modified Packages", path:"/approval",icon:approvapending},
    {title:"Expired Packages", path:"/expired-packages",icon:approvapending}
];

const Sidebar = () => {
  const [vendor, setVendor] = useState({});
  const [showPopup, setShowPopup] = useState(false);
  const [countdown, setCountdown] = useState(5);
  const navigate = useNavigate();

  const fetchVendor = () => {
    const vendorId = localStorage.getItem("vendorId");
    if (vendorId) {
      api
        .get(`/vendor/get/${vendorId}`)
        .then((res) => setVendor(res.data.data || {}))
        .catch(() => setVendor({}));
    }
  };

  useEffect(() => {
    fetchVendor();
    const handleProfileUpdate = () => fetchVendor();
    window.addEventListener("profileUpdated", handleProfileUpdate);
    return () =>
      window.removeEventListener("profileUpdated", handleProfileUpdate);
  }, []);

  useEffect(() => {
    let timer;
    if (showPopup && countdown > 0) {
      timer = setInterval(() => {
        setCountdown((prev) => prev - 1);
      }, 1000);
    } else if (showPopup && countdown === 0) {
      // Timer reached 0: close popup
      setShowPopup(false);
    }
    return () => clearInterval(timer);
  }, [showPopup, countdown]);

  const handleClick = (item) => {
    const missingInfo = !vendor.gstin;

    if (
      missingInfo &&
      (item.path === "/manage-user" || item.path === "/manage-package")
    ) {
      setShowPopup(true);
      setCountdown(5); // reset countdown
      return;
    }

    navigate(item.path);
  };

  const handlePopupOk = () => {
    setShowPopup(true);
    navigate("/profile-view");
  };

  return (
    <>
      {/* Popup */}
      {showPopup && (
        <div
          style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            background: "#BC6C25",
            color: "white",
            padding: "20px 25px",
            borderRadius: "8px",
            fontWeight: 600,
            boxShadow: "0 4px 8px rgba(0,0,0,0.3)",
            textAlign: "center",
            minWidth: "300px",
            zIndex: 9999,
          }}
        >
          <p style={{ marginBottom: "10px", color: "white" }}>
            Please update your GSTIN and PAN in your profile before accessing
            this section.
          </p>
          <button
            onClick={handlePopupOk}
            style={{
              backgroundColor: "white",
              color: "#28a745",
              padding: "8px 20px",
              border: "none",
              borderRadius: "5px",
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            OK
          </button>
        </div>
      )}

      {/* Sidebar */}
      <div
        className="d-flex flex-column vh-100 sidebarhide"
        style={{
          width: "250px",
          backgroundColor: "white",
          position: "relative",
          zIndex: 2,
          borderRight: "1px solid #eee",
        }}
      >
        {/* Logo */}
        <div
          style={{
            height: "70px",
            display: "flex",
            justifyContent: "left",
            alignItems: "center",
            paddingLeft: "14px",
          }}
        >
          <img src={basharaat} alt="Logo" style={{ height: "40px" }} />
        </div>

        {/* Menu */}
        <div className="mt-4">
          <h6
            style={{ fontSize: "14px", fontWeight: "700", color: "#898989" }}
            className="px-3"
          >
            Menu
          </h6>

          {sidebarData.map((item, index) => (
            <div
              key={index}
              onClick={() => handleClick(item)}
              className="d-flex align-items-center px-3 py-2 gap-2"
              style={{
                cursor: "pointer",
                color: "#000",
                fontWeight: 600,
                borderRadius: "6px",
                margin: "4px 8px",
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.backgroundColor = "#f0f0f0")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.backgroundColor = "transparent")
              }
            >
              {item.icon && (
                <img src={item.icon} alt="icon" style={{ width: "20px" }} />
              )}
              <span>{item.title}</span>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Sidebar;
